import { BIGGEST_TURN_ON_COMPATIBILITY_OPTIONS } from '../BIGGEST_TURN_ON_COMPATIBILITY_OPTIONS';
import { BiggestTurnOnCompatibilityOptionIdType } from '../types';

export const getBiggestTurnOnCompatibilityTitleById = (
  id: BiggestTurnOnCompatibilityOptionIdType | null,
): string | null => {
  if (!id) return null;
  return (
    BIGGEST_TURN_ON_COMPATIBILITY_OPTIONS.find((option) => option.id === id)
      ?.title || null
  );
};

const DEFAULT: BiggestTurnOnCompatibilityOptionIdType = 'confidence';
export const getBiggestTurnOnCompatibilityIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): BiggestTurnOnCompatibilityOptionIdType | null => {
  const id = BIGGEST_TURN_ON_COMPATIBILITY_OPTIONS.find(
    (option) => option.title === title,
  )?.id;
  if (id) {
    return id;
  }
  if (withDefault) {
    return DEFAULT;
  }
  return null;
};
